// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"2bec36fae1f2c4db82b9","691":"02d622eebc868f1074a5"}[chunkId] + ".js";
};